import { render, staticRenderFns } from "./recommendOffer.vue?vue&type=template&id=6ae78dc4&scoped=true&"
import script from "./recommendOffer.vue?vue&type=script&lang=ts&"
export * from "./recommendOffer.vue?vue&type=script&lang=ts&"
import style0 from "./recommendOffer.scss?vue&type=style&index=0&id=6ae78dc4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae78dc4",
  null
  
)

export default component.exports